export default "__VITE_ASSET__DgfN2JE2__"